const config = () => ({
  desktopStreamUrl:
    'https://livestream.blick.ch/tv/?station={channel}&autoplay=true&partner=blick',
  mobileStreamUrl:
    'https://embed-zattoo.com/{channel}/?autoplay=true&&partner=blick',
  channelPlaceholderUrl: 'https://thumb.zattic.com/{channel}/1024x576.jpg',
})

export type configType = ReturnType<typeof config>
export default config
